// extracted by mini-css-extract-plugin
export default {"Card":"Card_Card__8tZ-f","Button":"Card_Button__N75kV","one":"Card_one__N1sio","two":"Card_two__f7HXD"};